import React, { useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const BG_IMAGE = "/assets/graphics/hero1.png";

const TempComingSoonLandingPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Integrate with waitlist/email service
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex flex-col justify-center items-center relative" style={{ minHeight: "80vh" }}>
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${BG_IMAGE})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/30 z-10" />
        </div>
        <div className="relative z-20 flex flex-col items-center justify-center w-full px-4 py-16">
          <div className="bg-white/80 rounded-xl shadow-lg flex items-center justify-center mb-8" style={{ width: 100, height: 100 }}>
            <span className="text-3xl font-bold text-sauna-navy">SD</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center mb-4">
            SaunaDip is <span className="text-sauna-orange">Heating Up</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 text-center mb-8 max-w-xl">
            A new way to discover saunas and cold dips across Ireland. Be the first to explore hidden gems and icy plunges.
          </p>
          {submitted ? (
            <div className="bg-white/90 rounded-lg px-6 py-4 text-sauna-navy font-semibold text-center mb-6 shadow">
              Thank you! You're on the waitlist.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 w-full max-w-xl mb-6 justify-center">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className="rounded-full px-6 py-3 bg-white/90 border-none shadow text-lg flex-1 min-w-0"
              />
              <Button
                type="submit"
                className="rounded-full px-8 py-3 text-lg font-semibold bg-gradient-to-r from-sauna-orange to-red-500 hover:from-sauna-orange/90 hover:to-red-500/90 shadow"
              >
                Join the Waitlist
              </Button>
            </form>
          )}
          <Button asChild variant="outline" className="rounded-full px-8 py-3 text-lg mt-2 bg-white/80 text-sauna-navy border-none shadow hover:bg-white">
            <a href="/">Back to Home</a>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TempComingSoonLandingPage; 